import * as React from 'react';
import { Calendar } from '@/components/ui/calendar';
import { cn } from '@/lib/utils';
import { enUS, ptBR } from 'date-fns/locale';
import { useI18nContext } from '@/i18n/i18n-react';

export interface DatePickerProps {
  value?: Date;
  onChange: (date: Date | undefined) => void;
  disabled?: boolean;
  fromDate?: Date;
  toDate?: Date;
  className?: string;
}

function DatePicker({
  value,
  onChange,
  disabled = false,
  fromDate,
  toDate,
  className,
}: DatePickerProps) {
  const { locale } = useI18nContext();

  const disabledDates = React.useMemo(() => {
    if (disabled) return true;

    const disabledRanges = [];
    if (fromDate) disabledRanges.push({ before: fromDate });
    if (toDate) disabledRanges.push({ after: toDate });

    return disabledRanges.length > 0 ? disabledRanges : undefined;
  }, [disabled, fromDate, toDate]);

  return (
    <div className={cn('w-fit', className)}>
      <Calendar
        mode="single"
        selected={value}
        onSelect={onChange}
        disabled={disabledDates}
        initialFocus
        locale={{ en: enUS, pt: ptBR }[locale]}
        classNames={{
          day_today: '',
        }}
      />
    </div>
  );
}

DatePicker.displayName = 'DatePicker';

export { DatePicker };
